


























import { Component, Mixins, Vue } from 'vue-property-decorator'
import LabelBase from '@/components/atoms/LabelBase.vue'
import LearningType from '@/mixins/historyv3/LearningType'
import NursingBranch from '@/mixins/v3/NursingBranch'

@Component({
  components: {
    LabelBase,
  },
})
export default class TeacherHistoryHeader extends Mixins(LearningType, NursingBranch) {
  get isActive(): any {
    return function (target: string) {
      // @ts-ignore
      const { path } = this.$route
      const active = path.split('/').slice(-1)[0]
      return {
        active: target === active,
      }
    }
  }
}
